// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-product-component-vars{--main-padding:24px;--border-width:1px;--border-color:var(--surface-black-t10)}.-product-component-vars.--border-left-hide{border-left-color:transparent}.-product-component-vars.--border-right-hide{border-right-color:transparent}.-product-component-vars.--border-top-hide{border-top-color:transparent}.-product-component-vars.--border-bottom-hide{border-bottom-color:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
